module.exports = __webpack_public_path__ + "static/media/s_v9_t3_2.5547d47f.mp3";